import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode } from "vue";
const _hoisted_1 = { class: "x_panel" };
const _hoisted_2 = { class: "x_title" };
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("h2", null, "Details", -1 /* HOISTED */);
const _hoisted_4 = { class: "nav navbar-right panel_toolbox float-end no-min-width" };
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-chevron-up" }, null, -1 /* HOISTED */);
const _hoisted_6 = [
    _hoisted_5
];
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("div", { class: "clearfix" }, null, -1 /* HOISTED */);
const _hoisted_8 = {
    key: 0,
    class: "x_content"
};
const _hoisted_9 = /*#__PURE__*/ _createElementVNode("div", { class: "spacer" }, null, -1 /* HOISTED */);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _renderSlot(_ctx.$slots, "title", {}, () => [
                _hoisted_3
            ]),
            _createTextVNode(),
            _createElementVNode("ul", _hoisted_4, [
                _renderSlot(_ctx.$slots, "action-menu"),
                _createTextVNode(),
                _createElementVNode("li", null, [
                    _createElementVNode("a", {
                        class: "collapse-link",
                        onClick: _cache[0] || (_cache[0] =
                            //@ts-ignore
                            (...args) => (_ctx.toggle && _ctx.toggle(...args)))
                    }, _hoisted_6)
                ])
            ]),
            _createTextVNode(),
            _hoisted_7
        ]),
        _createTextVNode(),
        _createVNode(_Transition, { name: "slide" }, {
            default: _withCtx(() => [
                (_ctx.visible)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        _renderSlot(_ctx.$slots, "default"),
                        _createTextVNode(),
                        _hoisted_9
                    ]))
                    : _createCommentVNode("v-if", true)
            ]),
            _: 3 /* FORWARDED */
        })
    ]));
}
